import { useAsyncData } from '#imports'
import { computed, watch } from 'vue'

import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'

import { useErrorLogger } from '../../../../composables/error-logger/useErrorLogger'

export function useCarePlatformHealth() {
  const $httpFetch = useHttpFetch()
  const logger = useErrorLogger('CARE_PLATFORM_HEALTH', [
    'bot-squad-care-platform-front',
  ])

  const { data: intercomData, error } = useAsyncData('intercom-health', () =>
    $httpFetch('/api/care-platform/v1/health/intercom'),
  )

  // First version: only the CloudBees-backed `forced` flag is live.
  // A fetch error stays false so the banner can never get stuck on (fail-closed).
  const intercomForced = computed(() => intercomData.value?.forced ?? false)

  watch(error, (value) => {
    if (value) {
      logger('Error while fetching intercom health', value)
    }
  })

  return {
    error,
    intercomForced,
  }
}
